import { Callout, DirectionalHint, Link, Stack, Text } from '@fluentui/react';
import React from 'react';
import { LookupCarrierSearch_lookupCarrierSearch_nodes } from '../__generated__/LookupCarrierSearch';
import { useStyles } from './index.styles';

export interface LookUpCalloutProps {
  data: LookupCarrierSearch_lookupCarrierSearch_nodes[];
  onDismiss?: () => void;
  targetID: string;
  onSelect: (value: LookupCarrierSearch_lookupCarrierSearch_nodes) => void;
  lookUpCalloutWidth?: number;
}

export const LookUpCallout: React.FC<LookUpCalloutProps> = ({
  onDismiss,
  data,
  targetID,
  onSelect,
  lookUpCalloutWidth,
}) => {
  const styles = useStyles();
  if (!data?.length) return null;
  return (
    <Callout
      onDismiss={onDismiss}
      gapSpace={10}
      isBeakVisible={false}
      className={styles.callout}
      directionalHint={DirectionalHint.bottomCenter}
      target={targetID}
      style={{ width: lookUpCalloutWidth }}
    >
      <Stack className={styles.searchAreaContainer}>
        <Stack>
          {data?.map((item, index) => {
            return (
              <Link
                onClick={() => {
                  onSelect(item);
                  onDismiss?.();
                }}
                className={styles.resultItem}
                key={item.id}
              >
                <Stack>
                  <Text>{item.name} </Text>
                </Stack>
              </Link>
            );
          })}
        </Stack>
      </Stack>
    </Callout>
  );
};
